import styled from "styled-components";


export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${props => props.theme.white1};
  min-height: 900px;
  height: 100vh;
  overflow: auto;
`;

export const ContentContainer = styled.div`
  min-width: max-content;
  min-height: 800px;
  background-color: ${props => props.theme.white1};
  position: relative;
  border: 1px solid ${props => props.theme.white4};
  margin: 20px;
  padding: 20px;
  margin-right: 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`;

export const FlexContainer = styled.div`
  display: flex;
`;

export const EditContainer = styled.div`
  min-width: max-content;
  padding: 5px 10px;
  margin: 10px 0;
  border-radius: 10px;
  background-color: ${props => props.theme.white3};

`;

export const Line = styled.div`
  min-height: 700px;
  height: 80vh;
  width: 1px;
  background-color: ${props => props.theme.black2};
  margin: 10px;
`;

export const EditSpan = styled.div`
  display: flex;
  align-items: center;

  h3,h4,h5,h6{
    min-width: 120px;
    margin: 0;
  }
  .MuiAutocomplete-root {
    width: 220px;
    height: 28px;
    margin: 5px;
    background-color: ${props => props.theme.white1};
    border-radius: 5px;
    color: unset;
    
    &:focus {
      outline: none;
    }
  }
  .MuiInputLabel-outlined:not(.MuiInputLabel-shrink) {
    font-weight: 500;
    font-family: unset;
    transform: unset;
    top: 5px;
    left: 15px;
    font-size: 13px;
    color: unset;
  }

  .MuiFormLabel-root{
    color: unset;
  }
  .MuiFormLabel-root.Mui-focused{
    color: unset;

  }
  .MuiAutocomplete-root .MuiOutlinedInput-root {
    height: 28px;
    color: unset;
    background-color: ${props => props.theme.white1};
  }
  .MuiOutlinedInput-notchedOutline{
    border: 0;
  }
  .MuiSvgIcon-root{
    color: ${props => props.theme.black1};
  }
  .MuiAutocomplete-paper{
    background-color: ${props => props.theme.white1};
    color: unset;
  }
`;

export const SelectContainer = styled.select`
  width: 220px;
  height: 28px;
  margin: 5px;
  margin-right: 20px;
  padding: 0 10px;
  border-radius: 5px;
  border: 0;
  background-color: ${props => props.theme.white1};
  color: unset;

  &:focus {
    outline: none;
  }
`;

export const Input = styled.input`
  background-color: ${props => props.theme.white1};
  color: unset;
  margin: 5px;
  padding-left: 15px;
  width: 220px;
  height: 28px;
  border-radius: 5px;
  border: 0;
  &:focus {
    outline: none;
  }
`;

export const TextArea = styled.textarea`
  background-color: ${props => props.theme.white1};
  min-width: 400px;
  height: 65vh;
  resize: none;
  outline: none;
  padding: 10px;
  border: 0;
  font-size: 14px;
  color: unset;
  
  &:focus {
    outline: none;
  }
`;

export const ButtonSpan = styled.span`
  height: 40px;
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
`;

export const Button = styled.button`
  background-color: ${props => props.theme.white3};
  color: unset;
  font-weight: 500;
  font-size: 18px;
  width: 100px;
  height: 32px;
  border-radius: 5px;
  border: 0;
  &:focus {
    outline: none;
  }
  &:hover {
    background-color: ${props => props.theme.white5};
  }
`;

export const ResultContainer = styled.div`
  background-color: ${props => props.theme.white1};
  height: 600px;
  min-width: 200px;
  overflow-y: scroll;
  padding: 5px;
`;
